export const userTypes = {
    Unauthenticated: -1,
    Unknown: 0,
    /** Parent or legal guardian of a scholarship applicant */
    Parent: 1,
    /** Representative of a private school */
    PrivateSchool: 2,
    /** Representative of a scholarship organization */
    ScholarshipOrg: 3,
    /** Shipyard administrator */
    Admin: 4,
};

/**Application Status
 * @deprecated Remove and replace with DB-driven statuses
 * #TechnicalDebt
 */
export const applicationStages = {
    undefined: 'AppStages.Undefined',
    1: 'AppStages.Started', //1
    2: 'AppStages.InitialReview', //2
    3: 'AppStages.Returned', //3
    4: 'AppStages.DHSReview', //4
    5: 'AppStages.SchoolReview', //5
    6: 'AppStages.Approved', //6
    7: 'AppStages.Denied', //7
    8: 'AppStages.Pending', //8
    9: 'AppStages.Accepted', //9
    10: 'AppStages.Declined', //10
    11: 'AppStages.Funded', //11
    12: 'AppStages.Withdrawn', //12
    13: 'AppStages.EnrollmentChange', //13
    14: 'AppStages.FinalReview',
};

export const authentication = {
    /** Cognito Multi-factor Authentication Challenge Types */
    challenge: {
        SMS: 'SMS_MFA',
    },
};

export const statementStages = ['StmtStages.Undefined', 'StmtStages.NotStarted', 'StmtStages.Created', 'StmtStages.Submitted', 'StmtStages.Approved'];

export const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const questionTypes = {
    SingleLinePlainText: 1,
    Dropdown: 2,
    Radio: 3,
    Checkbox: 4,
    DatePicker: 5,
    FileUpload: 6,
    SignaturePad: 7,
    LabelOnly: 8,
    OutputPreview: 9,
    Strikethrough: 10,
    Table: 12,
    MultiLinePlainText: 14,
    DropdownMultichoice: 15,
};

export const languageIds = {
    UserResponse: 0,
    'en-US': 1,
    'es-US': 187,
};

export const enrollmentChangeTypes = {
    Initial: 1,
    Renewal: 2,
    Transfer: 3,
    Withdrawal: 4,
    ImportInitial: 5,
    ImportRenewal: 6,
};

export const appTypes = {
    1: 'AppType.Initial',
    2: 'AppType.Renewal',
};

/**Returns the default landing URL for a given user type.
 * @param {number} userType User type of the logged in user.
 * @returns {string} Default landing URL.
 */
export const defaultLanding = (userType) => {
    switch (userType) {
        case userTypes.Parent:
            return '/applications';
        case userTypes.PrivateSchool:
            return '/students';
        case userTypes.ScholarshipOrg:
            return '/applications';
        case userTypes.Admin:
            return '/usersettings';
        case userTypes.Unauthenticated:
            return '/signin';
        default:
            console.error('Unknown user type encountered:', userType);
            return '/signin';
    }
};

export const grades = {
    PreK: 'GradeLevel.Levels.PreK',
    PreKH: 'GradeLevel.Levels.PreKH',
    K: 'GradeLevel.Levels.K',
    KH: 'GradeLevel.Levels.KH',
    G1: 'GradeLevel.Levels.G1',
    G2: 'GradeLevel.Levels.G2',
    G3: 'GradeLevel.Levels.G3',
    G4: 'GradeLevel.Levels.G4',
    G5: 'GradeLevel.Levels.G5',
    G6: 'GradeLevel.Levels.G6',
    G7: 'GradeLevel.Levels.G7',
    G8: 'GradeLevel.Levels.G8',
    G9: 'GradeLevel.Levels.G9',
    G10: 'GradeLevel.Levels.G10',
    G11: 'GradeLevel.Levels.G11',
    G12: 'GradeLevel.Levels.G12',
};
